import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import CustomizationEditor from '@/routes/customizations/CustomizationEditor'
import {
  customizationEditorRouteAction,
  customizationEditorRouteLoader,
} from '@/routes/customizations/CustomizationEditor.route'
import { RoleRouteObject } from '@/types'

const CustomizationCreatorRoute = {
  path: 'new',
  element: <CustomizationEditor creating={true} />,
  loader: customizationEditorRouteLoader,
  action: customizationEditorRouteAction,
  allowedRoles: [Roles.GlobalAdministrator, Roles.TechDeveloper, Roles.Supervisor, Roles.Administrator],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default CustomizationCreatorRoute
